<template>
  <AddClient
    ref="widget"
    :loading="loading"
    :external-id-only="useFeature('customer_external_id_only')"
    @submit="createClient"
    @closeModal="$emit('closeModal')"
  />
</template>

<script>

import { EventBus } from '@/event-bus';
import api from '@/_api';
import utilsMixin from '@/_utilities/utilsMixin';
import AddClient from './AddClient';

export default {
  name: 'AddClientContainer',
  components: {
    AddClient,
  },
  mixins: [utilsMixin],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    createClient(evt) {
      this.loading = true;
      const formData = new FormData();

      Object.keys(evt).forEach((e) => {
        if (e === 'birth_date') {
          if (evt[e]) formData.append(e, this.$moment(evt[e]).toISOString());
        } else {
          formData.append(e, evt[e]);
        }
      });
      api.post('/customer/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((r) => {
        this.$emit('closeModal');
        this.$nextTick(() => {
          this.$router.push(`/clients/${r.data.pk}`).then(() => {
            EventBus.$emit('toast-success', 'Customer created successfully');
            this.$mixpanel.track('new_client', {
              account_id: this.$store.state.account.user.user.email,
            });
          });
        });
      }).catch((error) => {
        console.log('Got validation error from /customer/: ');
        console.dir(error);
        if (error.response.status === 400) {
          // FIXME: This looks awful. Should be redesigned.
          EventBus.$emit(
            'toast-error',
            `${Object.values(error.response.data).join()}`,
          );
        } else {
          EventBus.$emit(
            'toast-error',
            'Failed creating customer, please wait a few seconds and try again',
          );
        }
      })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
